import * as React from 'react';
import { IEditableServerSettings } from '../../../../ts/ServerApi/types/IEditableServerSettings';
import { BaseReactSettingsCtrlProps } from '../../../controllers/BaseReactSettingsCtrl';
import { IServerTimestamps } from '../../../services/ServerSettings';
import { SectionContainerBaseProps, SettingsFormikContainer } from '../GeneralSettingsPageBase';

/**
 * A partial list of server settings.
 * This is meant for individual section components to pick a subset of the overall settings they use
 */
export type ServerSettingsProps<T extends keyof IEditableServerSettings = keyof IEditableServerSettings> = {
  settings: Pick<IEditableServerSettings, T>;
  serverTimestamps?: IServerTimestamps;
};

export type OuterServerSettingsProps = BaseReactSettingsCtrlProps & SectionContainerBaseProps
  & ServerSettingsProps;

export function ReactServerSettings(props: OuterServerSettingsProps){
  return <SettingsFormikContainer {...props} />;
}
